// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__Z1tn4","productName":"Table_productName__33Lbg"};